import React, {
  Children,
  cloneElement,
  useCallback,
  useEffect,
  useState,
} from 'react';
import without from 'lodash/without';
import concat from 'lodash/concat';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import xor from 'lodash/xor';
import includes from 'lodash/includes';
import { Input } from 'modules/ui';
import { useDidMount } from 'modules/core/services/hooks';
// import { useWhatChanged } from '@simbathesailor/use-what-changed';

export default function OptionGroup({
  setFormValue,
  value = false,
  name,
  disabled,
  children,
  onChange,
  ...otherProps
}) {
  const [optionValues, setOptionValues] = useState(value || []);
  const didMount = useDidMount();

  const handleSetOptionValues = useCallback(
    resolvedValues => {
      const compactedValues = compact(resolvedValues);
      setOptionValues(compactedValues);

      if (setFormValue) {
        setFormValue(name, compactedValues);
      }

      if (onChange) {
        onChange(compactedValues);
      }
    },
    [name, onChange, setFormValue],
  );

  // useWhatChanged([value, didMount, handleSetOptionValues, optionValues]);
  useEffect(() => {
    function hasChange() {
      return !isEmpty(xor(value, optionValues));
    }

    if (didMount && hasChange()) {
      handleSetOptionValues(value);
    }
  }, [value, didMount, handleSetOptionValues, optionValues]);

  function handleChange(clickedValue) {
    const resolvedValues = includes(optionValues, clickedValue)
      ? without(optionValues, clickedValue)
      : concat(optionValues, clickedValue);

    handleSetOptionValues(resolvedValues);
  }

  function renderChild(child) {
    const {
      props: { value: childValue },
    } = child;

    const selected = includes(optionValues, childValue);

    return cloneElement(child, {
      name,
      selected,
      disabled,
      isCheckbox: true,
      onClick: () => handleChange(childValue),
    });
  }

  return <Input {...otherProps}>{Children.map(children, renderChild)}</Input>;
}
